import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import React from "react";
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import { Typography, Stack ,Button} from '@mui/material';
import { Link } from 'react-router-dom';
import { withTheme } from '@emotion/react';
import CITChip from '../../../Button/CITChip';
import Location from '../../../../assets/location.svg'
 


const CardSubtitle = (props) => {
    return (<Stack px='16px' pt="8px" pb='8px' spacing={2} direction="row" alignItems="center">
        <Avatar src={Location} sx={{ width: "16px", height: '16px' }}></Avatar>
        <Typography sx={{ ...props.theme.typography.sideNav, color: '#292727' }} noWrap>{'Fremont, California'}</Typography>
    </Stack>
    )
}


const JobCard = (props) => {

    const theme = props.theme

    return (
        <Card sx={{ height:{xs:350,sm:'344px'}, width: 'auto', padding: '8px' ,background: '#F8FBFF', borderRadius:'8px',
                    '&.MuiCard-root':{ boxShadow: '0px 4px 50px 0px rgba(0, 0, 0, 0.10) !important'}
                    }}>
            <CardHeader
                avatar={
                    <Avatar src={props.image} variant='square' sx={{ width: '48px', height: '48px' }}  aria-label="job icon">
                    </Avatar>
                }
                title={<Typography sx={theme.typography.heading}>{props.text}</Typography>}
            />
            <CardSubtitle theme={theme} />
            <CardContent>

                <Typography sx={{ ...props.theme.typography.bodyDescription, color: '#292727' }} color="text.secondary">
                    We are seeking a licensed psychologist to join our mental
                    health team. The ideal candidate will have a strong
                    background in psychological assessment counseling.
                </Typography>
                <Stack py="16px" direction="row" spacing={1}>
                    <CITChip  label="Full Time"></CITChip>
                    <CITChip  label="Min 2 years" ></CITChip>
                    <CITChip  label="Mid level" ></CITChip>
                </Stack>
            </CardContent>
            <CardActions  sx={{justifyContent:'space-between', paddingLeft:'16px', paddingRight:'16px'}} disableSpacing>
               <Typography sx={{ ...props.theme.typography.bodyDescription, color: '#292727' }} color="text.secondary">
                   3 days ago
                </Typography>
                 <Link style={{ textDecoration:'none'}} to={`jobs/${props.jobId}`}>
                    <Button   style={{ alignItems:'center', display:'flex', justifyContent:'center', color:'#1E87FF', height:'40px', borderRadius: '8px', border: '1px solid #1E87FF', paddingLeft:'24px', paddingRight:'24px', ...theme.typography.button}}  >
                        View job
                    </Button>
                </Link>
            </CardActions>
        </Card>
    );
}

export default withTheme(JobCard)